export default function UITrust() {
  const trustPoints = [
    { icon: "ri-shield-check-line", title: "Documentation", desc: "All our plots come with legally verified titles and transparent documentation." },
    { icon: "ri-leaf-line", title: "Eco-Friendly Development", desc: "Nature-inspired layouts with green open spaces, parks, and sustainable infrastructure." },
    { icon: "ri-map-pin-2-line", title: "Prime Bengaluru Locations", desc: "Strategically located on Sarjapur Road, Bengaluru's fastest-growing corridor." },
    { icon: "ri-home-heart-line", title: "Modern Amenities", desc: "Gated community with CCTV, 24/7 security, wide roads, and all essential utilities." },
    { icon: "ri-money-rupee-circle-line", title: "Strong Investment Value", desc: "Sarjapur Road is Bengaluru's fastest-growing corridor — ideal for long-term appreciation." },
    { icon: "ri-customer-service-2-line", title: "Easy Enquiry & Visit Support", desc: "Quick response on WhatsApp and phone. Site visits arranged at your convenience." },
  ];

  return (
    <section className="py-16 md:py-20 bg-[#EAF5E1]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-white text-[#7FBF3F] text-xs font-semibold px-4 py-2 rounded-full mb-4 border border-[#7FBF3F]/20">
            <i className="ri-award-line"></i>Why Choose Urban Infra
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#212121] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Trusted by 500+ Families in Bengaluru
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base">
            We build more than plots — we build trust, community, and long-term value for every family that chooses Urban Infra.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {trustPoints.map((point) => (
            <div key={point.title} className="bg-white rounded-2xl p-6 hover:-translate-y-1 border border-[#7FBF3F]/10 hover:border-[#7FBF3F]/30 transition-all duration-300 group">
              <div className="w-12 h-12 flex items-center justify-center bg-[#EAF5E1] rounded-xl mb-4 group-hover:bg-[#1B2A4A] transition-colors duration-300">
                <i className={`${point.icon} text-[#7FBF3F] text-xl group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-bold text-[#212121] text-base mb-2">{point.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{point.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-[#1B2A4A] rounded-2xl p-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { value: "9+", label: "Projects Completed" },
            { value: "500+", label: "Happy Families" },
            { value: "10+", label: "Years Experience" },
            { value: "100%", label: "Documentation Assured" },
          ].map((stat) => (
            <div key={stat.label}>
              <div className="text-4xl font-bold text-white mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.value}</div>
              <div className="text-[#7FBF3F] text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
